import { Modal, ModalProps } from "react-bootstrap";
import TakePhoto from "../compoment/features/canvasItems/TakePhoto";

interface MainMenuModalProps extends ModalProps {
  onHide: () => void;
  onPhotoReady?: (imageUrl: string) => void;
  /** Skip Freepik BG removal (needed for group-person extraction). */
  skipBackgroundRemoval?: boolean;
}

const TakePhotoModal = ({
  onHide,
  onPhotoReady,
  skipBackgroundRemoval,
  ...modalProps
}: MainMenuModalProps) => {
  return (
    <Modal
      {...modalProps}
      onHide={onHide}
      className={`takePhotoeModal`}
      keyboard={false}
      backdrop="static"
      centered
      scrollable={false}
    >
      <Modal.Body>
        <TakePhoto
          onClose={() => onHide()}
          onPhotoReady={onPhotoReady}
          skipBackgroundRemoval={skipBackgroundRemoval}
        />
      </Modal.Body>
    </Modal>
  );
};

export default TakePhotoModal;
